// Design tokens Starhub Creative (2026-10-22): gaya Gen Z neo-brutalism — krem hangat, tinta hitam,
// aksen api dari logo (oranye → merah, kuning matahari). Nama token sama dengan Eighteen supaya semua
// halaman yang membaca token ikut berganti tanpa diubah satu per satu.

export const colors = {
  bgPage: '#FFF8F0',
  bgCard: '#FFFFFF',
  bgCardMuted: '#FFF1E3',
  border: '#EBD9C6',
  borderStrong: '#0B0B0F',

  textPrimary: '#0B0B0F',
  textSecondary: '#5B5149',
  textMuted: '#9A8C80',

  accent: '#FF5A1F',
  accentMuted: '#FFE6D6',
  accentText: '#C2410C',

  gold: '#FFB800',
  goldMuted: '#FFF4CC',
  goldText: '#8A5A00',

  success: '#00A86B',
  successMuted: '#DBF7EA',
  warning: '#E08A00',
  warningMuted: '#FFF2D6',
  danger: '#E5243B',
  dangerMuted: '#FFE3E6',

  ink: '#0B0B0F',
  flame: 'linear-gradient(135deg,#FFB800 0%,#FF5A1F 45%,#FF2D2D 100%)',
};

export const radius = {
  sm: '10px',
  md: '14px',
  lg: '20px',
};

export const shadow = {
  card: '4px 4px 0 #0B0B0F',
};

export const styles = {
  page: {
    background: colors.bgPage,
    minHeight: '100vh',
    color: colors.textPrimary,
  },
  card: {
    background: colors.bgCard,
    border: `2px solid ${colors.ink}`,
    borderRadius: radius.lg,
    padding: '20px',
    boxShadow: shadow.card,
  },
  cardMuted: {
    background: colors.bgCardMuted,
    borderRadius: radius.md,
    padding: '16px',
  },
  buttonPrimary: {
    background: colors.flame,
    color: '#FFFFFF',
    border: `2px solid ${colors.ink}`,
    boxShadow: '3px 3px 0 #0B0B0F',
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  buttonSecondary: {
    background: colors.bgCard,
    color: colors.textPrimary,
    border: `2px solid ${colors.ink}`,
    boxShadow: '3px 3px 0 #0B0B0F',
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  badgeSuccess: {
    background: colors.successMuted,
    color: colors.success,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeWarning: {
    background: colors.warningMuted,
    color: colors.warning,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeDanger: {
    background: colors.dangerMuted,
    color: colors.danger,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
};
